import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';

class NavLink extends React.Component {
    render () {
        var self = this,
            liClass;

        liClass = classNames('nav-item', {
            'active': self.context.router.isActive(self.props.to)
        });

        return (
            <li className={ liClass }>
                <Link className="nav-link" to={ self.props.to }>{ self.props.children }</Link>
            </li>
        );
    }
};

NavLink.contextTypes = {
    router: React.PropTypes.object.isRequired
};

export default NavLink;


// WEBPACK FOOTER //
// ./src/app/components/helpers/navLink.js